import { Component, OnInit, OnChanges, SimpleChanges, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { DatePipePipe } from '../../pipes/date-pipe.pipe';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, Router, RouterEvent } from '@angular/router';
import { ManageWorkflowService } from 'src/app/modules/manage-workflows/services/manage-workflow.service';
import { ConsentPublishDetails } from 'src/app/shared/models/manageWorkflow.model';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { ToasterNotificationService } from '../toaster-notification/toaster-notification.service';
import { CONSENT_TO_PUBLISH_ERROR, CONSENT_TO_PUBLISH_SUBMITTED, FILL_ALL_MANDATORY_FIELDS } from '../../constants/messages';
import { TextValidator } from '../../validators/textPatternValidator';
import { LoggingService } from 'src/app/core/services/logging.service';
import { MANAGE_WORKFLOWS_URL, NOTIFICATION_ERROR } from '../../constants/constant';
import { ignoreElements } from 'rxjs/operators';

@Component({
  selector: 'app-consent-to-publish',
  templateUrl: './consent-to-publish.component.html',
  styleUrls: ['./consent-to-publish.component.scss']
})

export class ConsentToPublishComponent implements OnInit, OnChanges {
  public showLoader = false;
  public alert: NotificationAlert = null;
  public consentPublishFormGroupControl: FormGroup;
  public consentPublishReportFormGroupControl: FormGroup;
  public editNoninationForm = false;
  public publishData: any; //ConsentPublishDetails
  @Input() isNonConsentedCP = false;
  @Input() assingId: string;
  @Input() workflowID: string;
  @Input() yearCode: string;
  @Input() usingAsElement = false;
  public successMessage: string;
  public workflowStatus: string;
  public workflowUser: string;
  public showSubmitSuccessPopup: boolean;
  public submitConsentForm = false;
  public showErrorMessage = false;
  public showMandatoryErrorMessage = false;
  public minDate: any;
  public isAdmin = false;
  public headerText = 'Competent Person Consent to Publish';
  public userTypeText = 'Competent Person';

  @Output() onClose = new EventEmitter();

  constructor(private router: Router,
    private toasterNotificationService: ToasterNotificationService,
    private loggingService: LoggingService,
    private route: ActivatedRoute,
    private _location: Location, private manageWorkflowService: ManageWorkflowService) {
    this.route.params.subscribe(params => {
      try {
        this.assingId = params.id;
        this.workflowID = params.workflowId;
        this.yearCode = params.yearCode;
      }
      catch (exception) {
        this.loggingService.logTrace('consent-to-publish -> constructor ' + exception);
      }
    });
  }

  ngOnInit(): void {
    try {
      this.showLoader = true;
      this.showSubmitSuccessPopup = false;
      if (this.router.url.indexOf('/' + MANAGE_WORKFLOWS_URL) > -1) {
        this.isAdmin = true;
      }

      const minDate = new Date();
      minDate.setDate(minDate.getDate());
      this.minDate = { year: minDate.getFullYear(), month: minDate.getMonth() + 1, day: minDate.getDate() };
      this.manageWorkflowService.getConsentPublishDetails(this.workflowID, this.yearCode, this.assingId).subscribe(
        (response) => {
          this.showLoader = false;
          this.publishData = response;
          let consentText = this.publishData.consentText;
          this.workflowStatus = this.publishData.workflowStatus;
          this.workflowUser = this.publishData.workflowUser;
          if (this.publishData.workflowID) {
            const workflowIDArr = this.publishData.workflowID.split('.');
            let isUSSECWorkflow = workflowIDArr[workflowIDArr.length - 1] == 2;
            this.publishData.reportingCompanyName = "BHP";
            this.publishData.reportReleasingCompanyName="BHP";
            if (isUSSECWorkflow) {
              this.headerText = 'Qualified Person Consent to Publish';
              this.userTypeText = 'Qualified Person';
              this.publishData.reportName = this.publishData.reportName != "" ? this.publishData.reportName : "Form 20-F";
            } else {
              this.headerText = 'Competent Person Consent to Publish';
              this.userTypeText = 'Competent Person';
              this.publishData.reportName = this.publishData.reportName != "" ? this.publishData.reportName : "Annual Report"
            }
          }
          var elementId = window.document.getElementById("renderHTMLData");
          if (this.workflowStatus === '1' && !this.isAdmin && !this.isNonConsentedCP) {
            consentText = consentText.replace('[checkbox1]', '<input type=checkbox onclick=statementChange() id=isMiningRuleAccepted name=checkbox1 value=checkbox1>');
            consentText = consentText.replace('[checkbox2]', '<input type=checkbox onclick=statementChange() id=isExperiencedCPQP name=checkbox2 value=checkbox2>');
            consentText = consentText.replace('[checkbox3]', '<input type=checkbox onclick=statementChange() id=isMemberOfAuthorisedInstitute name=checkbox3 value=checkbox3>');
            consentText = consentText.replace('[checkbox4]', '<input type=checkbox onclick=statementChange() id=isReportsReviewed name=checkbox4 value=checkbox4>');
            consentText = consentText.replace('[checkbox5]', '<input type=checkbox onclick=statementChange() id=isBHPEmployee name=checkbox5 value=checkbox5>');
            consentText = consentText.replace('[checkbox6]', '<input type=checkbox onclick=statementChange() id=isConsultant name=checkbox6 value=checkbox6>');
            consentText = consentText.replace('[checkbox7]', '<input type=checkbox onclick=statementChange() id=isExternalEmployee name=checkbox7 value=checkbox7>');
          } else {
            consentText = consentText.replace('[checkbox1]', '<input type=checkbox id=isMiningRuleAccepted name=checkbox1 value=checkbox1 disabled>');
            consentText = consentText.replace('[checkbox2]', '<input type=checkbox id=isExperiencedCPQP name=checkbox2 value=checkbox2 disabled>');
            consentText = consentText.replace('[checkbox3]', '<input type=checkbox id=isMemberOfAuthorisedInstitute name=checkbox3 value=checkbox3 disabled>');
            consentText = consentText.replace('[checkbox4]', '<input type=checkbox id=isReportsReviewed name=checkbox4 value=checkbox4 disabled>');
            consentText = consentText.replace('[checkbox5]', '<input type=checkbox id=isBHPEmployee name=checkbox5 value=checkbox5 disabled>');
            consentText = consentText.replace('[checkbox6]', '<input type=checkbox id=isConsultant name=checkbox6 value=checkbox6 disabled>');
            consentText = consentText.replace('[checkbox7]', '<input type=checkbox id=isExternalEmployee name=checkbox7 value=checkbox7 disabled>');
          }
          elementId.innerHTML = consentText;
          let isDataAvailable = true;
          document.getElementById('isMiningRuleAccepted')['checked'] = Number(this.publishData.isMiningRuleAccepted);
          document.getElementById('isExperiencedCPQP')['checked'] = Number(this.publishData.isExperiencedCPQP);
          document.getElementById('isMemberOfAuthorisedInstitute')['checked'] = Number(this.publishData.isMemberOfAuthorisedInstitute);
          document.getElementById('isReportsReviewed')['checked'] = Number(this.publishData.isReportsReviewed);
          document.getElementById('isBHPEmployee')['checked'] = Number(this.publishData.isBHPEmployee);
          document.getElementById('isConsultant')['checked'] = Number(this.publishData.isConsultant);
          document.getElementById('isExternalEmployee')['checked'] = Number(this.publishData.isExternalEmployee);

          document.getElementById('isMiningRuleAccepted').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          document.getElementById('isExperiencedCPQP').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          document.getElementById('isMemberOfAuthorisedInstitute').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          document.getElementById('isReportsReviewed').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          document.getElementById('isBHPEmployee').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          document.getElementById('isConsultant').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          document.getElementById('isExternalEmployee').onclick = () => {
            this.showHideNominationErrorMessage();
          };
          this.consentPublishFormGroupControl = this.getNominationFormGroup(isDataAvailable, this.publishData);
          this.consentPublishReportFormGroupControl = this.getConsentFormGroup(isDataAvailable, this.publishData);
        });
    }
    catch (exception) {
      this.loggingService.logTrace('consent-to-publish.component -> constructor ' + exception);
    }
  }

  ngOnChanges(changes: SimpleChanges): void { }

  public showHideNominationErrorMessage(): void {
    if (document.getElementById('isBHPEmployee')['checked']
      || document.getElementById('isExternalEmployee')['checked']
      || document.getElementById('isConsultant')['checked']) {
      document.getElementById('errorMessage').style.display = 'none';
      this.showErrorMessage = false;
    } else {
      document.getElementById('errorMessage').style.display = 'block';
      this.showErrorMessage = true;
    }
    if ((document.getElementById('isMiningRuleAccepted')['checked']
      && document.getElementById('isExperiencedCPQP')['checked']
      && document.getElementById('isMemberOfAuthorisedInstitute')['checked']
      && document.getElementById('isReportsReviewed')['checked'])
    ) {
      document.getElementById('errorMandatoryMessage').style.display = 'none';
      this.showMandatoryErrorMessage = false;
    } else {
      document.getElementById('errorMandatoryMessage').style.display = 'block';
      this.showMandatoryErrorMessage = true;
    }
  }


  @HostListener('window:click') statementChange(event) {
    if ((document.getElementById('isBHPEmployee') !== null && document.getElementById('isBHPEmployee')['checked'])) {
      document.getElementById('isConsultant')['disabled'] = true;
      document.getElementById('isExternalEmployee')['disabled'] = true;
    } else if ((document.getElementById('isConsultant') !== null && document.getElementById('isConsultant')['checked'])) {
      document.getElementById('isBHPEmployee')['disabled'] = true;
      document.getElementById('isExternalEmployee')['disabled'] = true;
    } else if ((document.getElementById('isExternalEmployee') !== null && document.getElementById('isExternalEmployee')['checked'])) {
      document.getElementById('isBHPEmployee')['disabled'] = true;
      document.getElementById('isConsultant')['disabled'] = true;
    } else {
      if (document.getElementById('isMiningRuleAccepted')) {
        document.getElementById('isMiningRuleAccepted')['disabled'] = false;
      }
      document.getElementById('isExperiencedCPQP')['disabled'] = false;
      document.getElementById('isMemberOfAuthorisedInstitute')['disabled'] = false;
      document.getElementById('isBHPEmployee')['disabled'] = false;
      document.getElementById('isConsultant')['disabled'] = false;
      document.getElementById('isExternalEmployee')['disabled'] = false;
      document.getElementById('isReportsReviewed')['disabled'] = false;
    }
  }

  getNominationFormGroup(isDataAvailable: boolean, publishData) {
    const formFields: any = {};
    const signedCompetentPerson = {
      value: publishData.cpqpFullName,
      disabled: isDataAvailable,
    };
    let consentDate = publishData.consentDate.toString().split(' ')[0];
    consentDate = consentDate.toString().split('/');
    publishData.consentDate =
      consentDate[1] + '/' + consentDate[0] + '/' + consentDate[2];

    const signedCompetentPersonDate = {
      value: publishData.consentDate,
      disabled: isDataAvailable,
    };

    const professionalMembership = {
      value: publishData.professionalMembership,
      disabled: isDataAvailable,
    };
    const membershipNumber = {
      value: publishData.membershipNumber,
      disabled: isDataAvailable,
    };

    formFields.signedCompetentPerson = new FormControl(signedCompetentPerson, [Validators.required]);
    formFields.signedCompetentPersonDate = new FormControl(signedCompetentPersonDate, [Validators.required]);
    formFields.professionalMembership = new FormControl(professionalMembership, [Validators.required]);
    formFields.membershipNumber = new FormControl(membershipNumber, [Validators.required]);


    return new FormGroup(formFields);
  }

  getConsentFormGroup(isDataAvailable: boolean, publishData) {
    const formFields: any = {};
    // publishData.reportDate = new DatePipePipe().transform(publishData.reportDate, 'DD/MM/yyyy');
    //const reportName = { value: publishData.reportName, disabled: this.workflowStatus === '1' && this.isAdmin != true && this.isNonConsentedCP != true ? false : isDataAvailable };
    //const releaseReport = { value: publishData.reportReleasingCompanyName, disabled: this.workflowStatus === '1' && this.isAdmin != true && this.isNonConsentedCP != true ? false : isDataAvailable };
    const reportName = { value: publishData.reportName, disabled:  true};
    const releaseReport = { value: publishData.reportReleasingCompanyName, disabled:  true};
    const depositeName = { value: publishData.reportingDepositName, disabled: isDataAvailable };
    const releaseReportDate = { value: publishData.reportDate === '01/01/1900' ? '' : publishData.reportDate, disabled: this.workflowStatus === '1' && this.isAdmin != true && this.isNonConsentedCP != true ? false : isDataAvailable };

    formFields.reportName = new FormControl(reportName, [Validators.required, TextValidator(100)]);
    formFields.releaseReport = new FormControl(releaseReport, [Validators.required, TextValidator(100)]);
    formFields.depositeName = new FormControl(depositeName, [Validators.required]);
    formFields.releaseReportDate = new FormControl(releaseReportDate, [Validators.required]);
    return new FormGroup(formFields);
  }

  onCancel() {
    if (this.usingAsElement) {
      this.onClose.emit();
    } else {
      this._location.back();
    }
  }

  onSubmitNomination() {
    this.submitConsentForm = true;
    this.showHideNominationErrorMessage();
    if (!this.showErrorMessage && !this.showMandatoryErrorMessage && this.consentPublishReportFormGroupControl.valid) {
      this.showLoader = true;
      const publishDataReport = this.consentPublishFormGroupControl.getRawValue();
      const publishData = this.consentPublishReportFormGroupControl.getRawValue();
      let releaseReportDate = publishData.releaseReportDate.toString().split('/');
      publishData.releaseReportDate = releaseReportDate[2] + '' + releaseReportDate[1] + '' + releaseReportDate[0];
      if (this.publishData.reportingPeriodEndDate !== undefined && this.publishData.reportingPeriodEndDate !== '') {
        let reportingPeriodEndDate = this.publishData.reportingPeriodEndDate.toString().split('/');
        this.publishData.reportingPeriodEndDate = reportingPeriodEndDate[2] + '' + reportingPeriodEndDate[1] + '' + reportingPeriodEndDate[0];
      }
      let data = {
        actionID: 1,
        yearCode: this.publishData.yearCode,
        workflowID: this.publishData.workflowID,
        loginID: this.publishData.loginID,
        TemplateID: this.publishData.templateID,
        ReportName: publishData.reportName,
        ReportReleasingCompanyName: publishData.releaseReport,
        AssignedDepositName: this.publishData.reportingDepositName,
        ReportDate: publishData.releaseReportDate,
        CPQPFullName: publishDataReport.signedCompetentPerson,
        IsMiningRuleAccepted: document.getElementById('isMiningRuleAccepted')['checked'] ? '1' : '0',
        IsExperiencedCPQP: document.getElementById('isExperiencedCPQP')['checked'] ? '1' : '0',
        IsMemberOfAuthorisedInstitute: document.getElementById('isMemberOfAuthorisedInstitute')['checked'] ? '1' : '0',
        IsBHPEmployee: document.getElementById('isBHPEmployee')['checked'] ? '1' : '0',
        IsConsultant: document.getElementById('isConsultant')['checked'] ? '1' : '0',
        isExternalEmployee: document.getElementById('isExternalEmployee')['checked'] ? '1' : '0',
        isReportsReviewed: document.getElementById('isReportsReviewed')['checked'] ? '1' : '0',
        ReportingDepositName: this.publishData.reportingDepositName,
        ReportingCompanyName: this.publishData.reportingCompanyName,
        ReportingPeriodEndDate: this.publishData.reportingPeriodEndDate,
        ConsentPublishedByName: this.publishData.consentPublishedByName,
        ConsentDate: publishDataReport.consentDate,
        ProfessionalMembership: publishDataReport.professionalMembership,
        MembershipNumber: publishDataReport.membershipNumber,
        RejectReason: '',
      };
      this.manageWorkflowService.submitConentToPublishForReview(data).subscribe((resolve) => {
        this.showLoader = false;
        this.showSubmitSuccessPopup = true;
        this.submitConsentForm = false;
        this.successMessage = CONSENT_TO_PUBLISH_SUBMITTED;
      }, (error) => {
        this.toasterNotificationService.showErrorNotification(CONSENT_TO_PUBLISH_ERROR);
      });
    } else {
      this.alert = { type: NOTIFICATION_ERROR, message: FILL_ALL_MANDATORY_FIELDS };
    }
  }

  public goBackToConsentToPublish(): void {
    if (this.router.url) {
      this.router.navigateByUrl(this.router.url.substr(1, this.router.url.indexOf('/consent-to-publish')).slice(0, -1));
    }
  }

}

